import {Component, EventEmitter, Input, Output} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    selector: "woa-field-group",
    templateUrl: "./field-group.component.html",
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: FieldGroupComponent, multi: true}]
})
export class FieldGroupComponent {
    @Input() title: string;
    @Input() translationParams: any = {};

    @Output() onActivateTitle: EventEmitter<void> = new EventEmitter();
}



// WEBPACK FOOTER //
// ./src/app/inputs/form/field-group/field-group.component.ts